import type {
  SearchAutoCompletionParams,
  SearchProductsParams,
} from '~/api/data-source/search';
import { searchRepository } from '~/api/repository/search';
import { getAssetUrl } from '~/utils/asset';

export const SEARCH_QUERY_KEY = {
  all: ['search'] as const,

  // 검색 상품 목록 (무한 스크롤, 커서 페이지네이션)
  list: (params: SearchProductsParams) => ({
    queryKey: ['/api/market-place/v1/search/products', params] as const,
    queryFn: ({ pageParam }: { pageParam?: string[] } = {}) =>
      searchRepository.getSearchProducts({
        ...params,
        searchAfter: pageParam,
      }),
    infinite: true,
  }),

  // 검색 상품 총 개수
  count: (params: SearchProductsParams) => ({
    queryKey: ['/api/market-place/v1/search/products/count', params] as const,
    queryFn: () => searchRepository.getSearchProductsCount(params),
  }),

  // 검색어 자동완성
  autoCompletion: (params: SearchAutoCompletionParams) => ({
    queryKey: ['/api/market-place/v1/search/auto-completion', params] as const,
    queryFn: () => searchRepository.getSearchAutoCompletion(params),
  }),

  // 최근 검색어
  recentKeywords: () => ({
    queryKey: ['/api/market-place/v1/recently/search-keywords'] as const,
    queryFn: () => searchRepository.getRecentSearchKeywords(),
  }),

  // 인기 검색어 (정적 에셋)
  recommendKeywords: () => ({
    queryKey: ['recommend-search-keywords'] as const,
    queryFn: async () => {
      const res = await fetch(
        getAssetUrl('files/marketplace-recommend-keyword-7', 'json'),
      );
      return (await res.json()) as { recommendKeywords: string[] };
    },
  }),
};
